import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { PatchResponseBody } from '../types/api-response';
import { TrialBalanceAccountingBasisEnum, Workpaper, WorkpaperRoleEnum, WorkpaperStatusEnum } from '../types/workpaper';
import queryClient from '../query-client';

export type UpdateWorkpaperFields = {
    status?: WorkpaperStatusEnum;
    name?: string;
    periodEnd?: string;
    dueDate?: string;
    accountingBasis?: TrialBalanceAccountingBasisEnum;
    materialityLimit?: { amount: number | null; isPercentage: boolean | null };
    assigned?: { role: WorkpaperRoleEnum; userId: string }[];
    guests?: string[];
    procedureTemplateId?: string;
    checklistId?: string;
    private?: boolean;
    provider?: 'XERO';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    integrations?: any;
    priorWorkpaperId?: string;
};

export type UpdateWorkpapersRequest = {
    id: string;
    fields: UpdateWorkpaperFields;
}[];

export type UpdateWorkpaperResponse = {
    workpaper: Workpaper;
    refreshXeroTrialBalanceResult?: { createdCount: number; updatedCount: number; excludedCount: number };
};

async function updateWorkpapers(request: UpdateWorkpapersRequest): Promise<PatchResponseBody<UpdateWorkpaperResponse>> {
    const { data } = await api.patch('/workpapers', request);
    return data;
}

export function useUpdateWorkpapers(): UseMutationResult<
    PatchResponseBody<UpdateWorkpaperResponse>,
    AxiosError,
    UpdateWorkpapersRequest,
    unknown
> {
    return useMutation(updateWorkpapers, {
        onSettled: () => {
            queryClient.invalidateQueries(['user-workpaper-role']);
            queryClient.invalidateQueries(['workpapers']);
            queryClient.invalidateQueries(['invitations']);
        },
    });
}
